type Translate = (key: string) => string;

type ShiftApiError = {
  response?: {
    data?: {
      message?: unknown;
    };
  };
  message?: unknown;
  detail?: unknown;
};

const SHIFT_API_ERROR_TRANSLATION_KEYS: Record<string, string> = {
  approved_absence_exists: 'The worker has an approved absence during this shift'
};

const asMessage = (value: unknown): string | undefined => (typeof value === 'string' && value.trim().length > 0 ? value : undefined);

export const formatShiftSubmissionErrorMessage = (baseMessage: string, errors: string[]): string => {
  const details = errors.filter(Boolean).join(', ');

  return details ? `${baseMessage}: ${details}` : baseMessage;
};

export const resolveShiftApiErrorMessage = (error: unknown, translate: Translate, fallbackKey: string): string => {
  const apiError = error && typeof error === 'object' ? (error as ShiftApiError) : undefined;
  const message = asMessage(apiError?.response?.data?.message) ?? asMessage(apiError?.message) ?? asMessage(apiError?.detail);
  const translationKey = message ? SHIFT_API_ERROR_TRANSLATION_KEYS[message] : undefined;

  return translationKey ? translate(translationKey) : (message ?? translate(fallbackKey));
};
